import stPropertySearch from './propertySearch.component';
import stPropertyDetails from './propertyDetails.component';

export default angular
  .module('st.Integrations.PropertyData', [])
  .component('stPropertySearch', stPropertySearch)
  .component('stPropertyDetails', stPropertyDetails);
